import moment from 'moment';

const path = document.location.pathname;
const linkMoment = moment().date() < 27 ? moment() : moment().add(1, 'months');
const displayMonth = linkMoment.format('MMMM');
const displayYear = linkMoment.format('YYYY');
const linkMonthYear = linkMoment.format('MMMM-YYYY').toLowerCase();
const dropdowns = [
    {
        regex: /^\/daily-horoscope(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Get Your Moon and Rising Sign',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Celtic Cross Tarot Reading',
                    url: '/readings-reports/tarot-readings/celtic-cross',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: `${displayMonth} Horoscope`,
                url: `/horoscopes/${linkMonthYear}`,
            },
        ],
    },
    {
        regex: /^\/daily-love-horoscope(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Relationship Bottom Line Tarot Reading',
                    url: '/readings-reports/tarot-readings/bottom-line/relationship',
                },
            },
            {
                label: 'Get Your Moon and Rising Sign',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Love Celtic Cross Tarot Reading',
                    url: '/readings-reports/tarot-readings/celtic-cross/love',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: `${displayMonth} Love Horoscope`,
                url: `/horoscopes/${linkMonthYear}-love`,
            },
        ],
    },
    {
        regex: /^\/daily-tarot-card(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Get Your Tarot Birth Card',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Celtic Cross Tarot Reading',
                    url: '/readings-reports/tarot-readings/celtic-cross',
                },
            },
            {
                label: 'Weekly Tarot Reading',
                url: `/tarot/reading-${linkMonthYear}`,
            },
            {
                label: `${displayYear} Yearly Tarot Reading`,
                url: `/tarot/reading-${displayYear}`,
            },
        ],
    },
    {
        regex: /^\/daily-hexagram(\/.+)?$/i,
        links: [
            {
                label: 'Free I Ching Reading',
                url: 'https://product.tarot.com/oracle/iching-reading/basic.php',
                logged_in: {
                    label: 'Love I Ching Reading',
                    url: 'https://product.tarot.com/oracle/iching-reading/love/',
                },
            },
            {
                label: 'Get Your Chinese Zodiac Sign',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'I Ching Reading',
                    url: 'https://product.tarot.com/oracle/iching-reading/basic.php',
                },
            },
            {
                label: 'About the I Ching Hexagrams',
                url: '/eastern-wisdom#iching',
            },
            {
                label: 'About the Art of Feng Shui',
                url: '/eastern-wisdom#feng-shui',
            },
        ],
    },
    {
        regex: /^\/daily-number(\/.+)?$/i,
        links: [
            {
                label: 'Get Your Life Path Number',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Numerology Compatibility Report',
                    url: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=2',
                },
            },
            {
                label: 'Free Numerology Compatibility Report',
                url: 'https://product.tarot.com/numerology/getreport.php?state=ENTRY&chartId=4',
                logged_in: {
                    label: 'Numerology Forecast Report',
                    url: '/readings-reports/numerology-reports/1-year-forecast',
                },
            },
            {
                label: `${displayYear} Numerology Forecast`,
                url: `/numerology/${displayYear}-predictions`,
            },
            {
                label: 'Dating By the Numbers',
                url: '/articles/numerology/sun-numbers-dating-love-compatibility',
            },
        ],
    },
    {
        regex: /^\/daily-psychic-tip(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Get Your Moon and Rising Sign',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Celtic Cross Tarot Reading',
                    url: '/readings-reports/tarot-readings/celtic-cross',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: `${displayMonth} Horoscope`,
                url: `/horoscopes/${linkMonthYear}`,
            },
        ],
    },
    {
        regex: /^\/astrology\/weekly-love-horoscopes(\/.+)?$/i,
        links: [
            {
                label: 'FREE Love Compatibility',
                url: '/astrology/compatibility/love',
                logged_in: {
                    label: 'Soulmate Tarot Reading',
                    url: '/readings-reports/tarot-readings/soulmate',
                },
            },
            {
                label: 'FREE Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Reconciliation Tarot Reading',
                    url: '/readings-reports/tarot-readings/reconciliation',
                },
            },
            {
                label: `${displayMonth} Love Horoscope`,
                url: '/daily-love-horoscope',
                logged_in: {
                    label: `${displayMonth} Love Horoscope`,
                    url: '/horoscopes/monthly-love',
                },
            },
            {
                label: `${displayYear} Yearly Love Horoscope`,
                url: `/horoscopes/${displayYear}-love`,
            },
        ],
    },
    {
        regex: /^\/horoscopes\/(?:(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\w+\-)?20[0-9]{2}(\/.+)?-love$/i,
        links: [
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Relationship Bottom Line Tarot Reading',
                    url: '/readings-reports/tarot-readings/bottom-line/relationship',
                },
            },
            {
                label: 'Get Your Moon and Rising Sign',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Love Celtic Cross Tarot Reading',
                    url: '/readings-reports/tarot-readings/celtic-cross/love',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
                logged_in: {
                    label: 'Romantic Compatibility Report',
                    url: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=16',
                },
            },
            {
                label: 'Love and Compatibility',
                url: '/love-and-compatibility',
                logged_in: {
                    label: 'Personalized Love Forecast',
                    url: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=21',
                },
            },
        ],
    },
    {
        regex: /^\/horoscopes\/(?:(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)\w+\-)?20[0-9]{2}(\/.+)?$/i,
        links: [
            {
                label: 'Daily Reflection Tarot Reading',
                url: '/readings-reports/tarot-readings/daily-reflection',
            },
            {
                label: 'Get Your Moon and Rising Sign',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Revelation Tarot Reading',
                    url: '/readings-reports/tarot-readings/revelation',
                },
            },
            {
                label: 'Born on the Cusp',
                url: '/astrology/cusps/born-on-the-zodiac-cusp',
                logged_in: {
                    label: '30-Day Forecast',
                    url: 'https://product.tarot.com/astrology/getreport.php?state=ENTRY&chart_ID=35',
                },
            },
            {
                label: 'View All Horoscopes',
                url: '/horoscopes',
            },
        ],
    },
].filter(({ regex }) => regex.test(path));

export const initial = dropdowns.length ? dropdowns[0].links : null;



// WEBPACK FOOTER //
// ./app/reducers/mobile-nav-dropdown.js